import styled from 'styled-components'

export const StyledApp = styled.div`
  text-align: center;
  min-height: 100vh;
  width: 100%;
  background: #4281a4;
  color: #ffffff;
`
